export default {
  isAuthenticated(state){
    return state.authenticated
  },
  getCompanies(state){
    return state.companies
  },
  getProviders(state){
    return state.providers
  },
  getUsers(state){
    return state.users
  },
  getCatalogs(state){
    return state.catalogs
  },
  isAdmin(state) {
    for (let i = 0; i < state.roles.length; i++) {
      if (state.roles[i] === 'ROLE_ADMIN') {
        return true;
      }
    }
    return false;
  },
  isUser(state) {
    for (let i = 0; i < state.roles.length; i++) {
      if (state.roles[i] === 'ROLE_USER') {
        return true;
      }
    }
    return false;
  },

  isChofer(state) {
    for (let i = 0; i < state.roles.length; i++) {
      if (state.roles[i] === 'ROLE_CHOFER') {
        return true;
      }
    }    
    return false;
  },
  isFlota(state) {
    for (let i = 0; i < state.roles.length; i++) {
      if (state.roles[i] === 'ROLE_FLOTA') {
        return true;
      }
    }    
    return false;
  },
  isInstalador(state) {
    for (let i = 0; i < state.roles.length; i++) {
      if (state.roles[i] === 'ROLE_INSTALADOR') {
        return true;
      }
    }    
    return false;
  },

  isActiveDevice(state, getters) {
    return (deviceToValidate) => {
      if (!deviceToValidate) {
        return false;
      }
      if (getters.isAdmin) {
        return true;
      }
      if (deviceToValidate.activated === false) {
        return false;
      }
      if (deviceToValidate.status === false) {
        return false;
      }

      if (
          deviceToValidate.renovationDate &&
          deviceToValidate.renovationDate < getters.getEcuadorDate
      ) {
        return false;
      }
      return true;
    };
  },


  msToTime: (state) => (ms) => {
    let seconds = Math.floor(ms / 1000);
    let minutes = Math.floor(ms / (1000 * 60));
    let hours = Math.floor(ms / (1000 * 60 * 60));
    let days = Math.floor(ms / (1000 * 60 * 60 * 24));

    if (isNaN(seconds) || isNaN(minutes) || isNaN(hours) || isNaN(days)) {
      return "Calculando...";
    }

    if (seconds < 60) return seconds + " seg.";
    else if (minutes < 60) return minutes + " min.";
    else if (hours < 24) {
      let remainingMinutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
      return hours + " hrs y " + remainingMinutes + " min.";
    } else {
      let remainingHours = Math.floor((ms % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      return days + " días y " + remainingHours + " hrs.";
    }
  },

  getEcuadorDate: () => {
    const now = new Date();
    const ecuadorDate = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Guayaquil',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(now);
    return ecuadorDate; // Format will be YYYY-MM-DD
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js